import axios from "axios";

const CHAT_API_KEY = "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";
const model4 = "gpt-4-1106-preview";

export async function GetChatContent(bodymsg) {
  const response = await axios.post(
    "https://api.openai.com/v1/chat/completions",
    {
      model: model4,
      messages: bodymsg,
      temperature: 0.7,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${CHAT_API_KEY}`,
      },
    }
  );
  return response;
}

export async function GetContentforParagraph(
  id,
  paralist,
  whichtext,
  paragraph = null,
  isAlternate = false,
  summarizeFor = []
) {
  const arrayDataItems = paralist.map((para) => para.heading);
  var priorResponce = arrayDataItems.join(" ");

  var contentmsg = `please provide content of ${id} paragraph that can be used in document itself, just a text without any explonations and headers`;

  if (isAlternate) {
    contentmsg = `please provide content of ${id} paragraph that can be used in document itself, just a text without any explonations and headers. Use this statement as referece '${paragraph}' but generate alternative version of this paragraph`;
  }

  const msgs = [
    {
      role: "system",
      content: "You are a helpful assistant.",
    },
    {
      role: "user",
      content: `Please generate 5 paragraph short names without description for ${whichtext}`,
    },
    {
      role: "assistant",
      content: priorResponce,
    },
    {
      role: "user",
      content: contentmsg,
    },
  ];

  if (Array.isArray(summarizeFor) && summarizeFor.length) {
    for (const priorMsg of summarizeFor) {
      if (priorMsg) {
        msgs.push({
          role: "user",
          content: "please provide alternative version of this paragraph for text above",
        });
        msgs.push({
          role: "assistant",
          content: priorMsg,
        });
      }
    }
    msgs.push({
      role: "user",
      content:
        "please summarize all version of this paragraph in one paragraph and provide final version that can be used in official document itself",
    });
  }

  const response = await axios
    .post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: model4,
        messages: msgs,
        temperature: 0.7,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${CHAT_API_KEY}`,
        },
      }
    )
    .catch(() => {
      return null;
    });
  if (Array.isArray(response.data?.choices) && response.data.choices.length && response.data.choices[0].message) {
    return response.data.choices[0].message.content;
  }
  return null;
}

export async function GetChatGPTResponses(howmany, whichtext) {
  const response = await axios
    .post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: model4,
        messages: [
          { role: "system", content: "You are a helpful assistant." },
          {
            role: "user",
            content: `Please generate ${howmany} paragraph short names without description for ${whichtext}`,
          },
        ],
        temperature: 0.7,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${CHAT_API_KEY}`,
        },
      }
    )
    .catch(() => {
      return null;
    });
  return response;
}
